module.exports = __webpack_public_path__ + "img/left.cdf09287.svg";